import BaseModel from 'volta/models/base-model';
import { _normalize, collectionCommand, resourceCommand } from 'volta/utils/api';

import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

import type { IUpdateUserRoleCmd } from 'volta/models/types/user';
import type { ICreateUserRoleCmd } from './types/user-role';

export const ResourceName = {
  singular: 'userRole',
  plural: 'userRoles'
};

export const Commands = {
  UpdateUserRole: 'UpdateUserRole',
  DeleteUserRole: 'DeleteUserRole',
  CreateUserRole: 'CreateUserRole'
};

export default class UserRole extends BaseModel {
  /**
   * Collection commands
   */

  static createUserRole = collectionCommand<ICreateUserRoleCmd, UserRole, typeof UserRole>(
    Commands.CreateUserRole
  );

  updateUserRole = resourceCommand<IUpdateUserRoleCmd, UserRole>(Commands.UpdateUserRole);
  deleteUserRole = resourceCommand(Commands.DeleteUserRole);

  @attr('string')
  declare name?: string;

  @attr('array', { defaultValue: () => [] })
  declare permissions: string[];

  @attr('boolean', { defaultValue: false })
  declare isDefault: boolean;

  [Type] = 'user-role' as const;
}
